import Api from "../../../../core/api";
import Quotas from "../../../../core/models/quotas";
import { ds } from "../../../../core/models/dataService";
import { trackActivity } from "../../../../core/utilities/utilities";
import { CustomerType } from "common/constants";

export default class BillingDataService {
    static async fetchSubscription(orgId) {
        const data = await Api.subscriptions.get({
            customer_type: orgId === undefined ? CustomerType.INDIVIDUAL : CustomerType.TEAM,
            organization_id: orgId,
        });
        return data[0];
    }

    static async fetchPaymentMethod(orgId) {
        let paymentMethodsResponse = await Api.paymentMethods.get({
            customer_type: orgId === undefined ? CustomerType.INDIVIDUAL : CustomerType.TEAM,
            organization_id: orgId
        });
        if (paymentMethodsResponse.body) {
            return paymentMethodsResponse.body[0];
        }
        return null;
    }

    static async fetchQuotas(orgId) {
        return Quotas.get(orgId || "personal");
    }

    static async cancelSubscription(subscriptionId, orgId, { immediate } = {}) {
        await Api.subscriptions.delete({
            subscriptionId,
            customerType: orgId === undefined ? CustomerType.INDIVIDUAL : CustomerType.TEAM,
            orgId,
            immediate
        });

        let sub = await this.fetchSubscription();
        if (sub) {
            let { interval, product, amount, current_period_end } = sub;
            const eventProps = {
                billing_term: interval,
                current_status: product,
                effective_date: current_period_end,
                amount: amount,
                plan: product,
                current_slide_count: ds.presentations.getWorkspaceSlideCount(orgId || "personal")
            };
            trackActivity("Upgrade", "BillingIntentCancel", null, null, eventProps, { audit: true });
        }
    }

    static async removePaymentMethod(paymentMethodId) {
        await Api.paymentMethods.delete({ paymentMethodId });
    }

    // HARDCODED :(
    static getPricing(plan, billingTerm) {
        const pricing = {
            pro: { year: 12 * 12, month: 15, yearPerMonth: 12 },
            team: { year: 38 * 12, month: 46, yearPerMonth: 38 },
            "team-migrated": { year: 12 * 12, month: 15, yearPerMonth: 12 },
            org: { year: 20 * 12, month: 25 }
        };
        return pricing[plan][billingTerm];
    }

    static applyCoupon(price, promo) {
        if (promo) {
            if (promo.amountOff) {
                const discountPrice = price - (promo.amountOff / 100); // cents -> dollars
                return Math.max(discountPrice, 0);
            } else {
                return price - (price / 100 * promo.percentOff);
            }
        } else {
            return price;
        }
    }
}
